<dmb-spinner />
<div class="login">
  <dmb-brand-logo></dmb-brand-logo>

  @if ((isLoggedIn | async) === false) {
    <div class="form">
      <form (ngSubmit)="onSubmit($event)" [formGroup]="webAuthFormGroup" id="loginForm">
        <dmb-input
          #username
          [control]="user"
          [required]="true"
          i18n-label="@@login.label.username"
          id="user"
          label="Username"></dmb-input>
        <dmb-input
          #password
          [control]="pass"
          [required]="true"
          i18n-label="@@login.label.password"
          id="pass"
          label="Password"
          type="password"></dmb-input>
        @if (image(); as img) {
          <dmb-qr-code [qrCode]="img"></dmb-qr-code>
        }
        @if (showTotpField()) {
          <dmb-input
            [control]="totp"
            i18n-label="@@login.label.totp.placeholder"
            id="totp"
            label="6-digit Authentication Code"></dmb-input>
        }
        @if (errorStatus()) {
          <dmb-login-errors [message]="errorMessage()" [status]="errorStatus()"></dmb-login-errors>
        }
        <dmb-button variant="primary" i18n="@@login.button.login" type="submit">Submit </dmb-button>
        @if (!showTotpField()) {
          <dmb-button (buttonClick)="passwordLost()" variant="flat" i18n="@@login.button.password-lost" type="button"
            >Forgot Password?
          </dmb-button>
        }
      </form>
    </div>
  }
  @if ((isLoggedIn | async) === true) {
    <div class="form" i18n="@@dmb-web.login.already-logged-in">You are logged in as {{ realName | async }}</div>
  }

  @if (!isWhiteLabelBrand) {
    <div class="login-link">
      Powered by&nbsp;<a href="https://kontornewmedia.com/en" i18n-href="@@link.kontor" target="_blank"
        >Kontor New Media GmbH</a
      >
    </div>
  }
</div>
